/**
 * Regpath Offer
 * Functionaity for a single offer page
 * 
 * Config Options
 * -- none
 */
 define('components/skip-button-support',[
    "jquery",
    "logging",
    "application"
], function($, logging, app) {
    "use strict";

    var _ModuleName = "Skip Button Support";
    var _config = {
        skipButtonId: ''
    };

    var init = function(data) {
        // get skip button id from data object
        _config.skipButtonId = typeof(data.skipButtonId) !== 'undefined' ? data.skipButtonId : _config.skipButtonId;
    }

    var run = function() {
        if (app.getProcessVersionNumber() == '2.0' && _config.skipButtonId != null && _config.skipButtonId != '')
        {
            var $button = $('#' + _config.skipButtonId);
            if ($button.length) {
                $button.click(function(e) {
                    logging.debug('skip button clicked', _ModuleName);
                    app.notifyParentOfSkip();
                });
            } else {
                logging.error('unable to find skip button with id ' + _config.skipButtonId, _ModuleName);
            }
        }
    }

    return {
        init: init,
        run: run
    }
});

